<template>
    <h1 class="title">
        <slot></slot>
    </h1>
</template>

<script>
export default {
    name: 'Title'
};
</script>

<style scoped>
.title {
    color: #323232;
    font-size: 1.8rem;
    margin-bottom: 1.5rem;
    font-weight: 600;
    border-bottom: 2px solid #13294B;
    padding-bottom: 0.5rem;
    display: inline-block;
}
</style>